/* Circadia Next (the student programme) page. Logged-in customers only (the section renders the app only for a customer). Reads GET /apps/dashboard/customer/student and posts to
   .../student/verify (join, or join again after the term) and .../student/renew (api/customer/student) with { consent, attest_age18, school_email }: the server emails ONE link to the school address and
   answers status 'email_sent'; the link's own page finishes the verification. The discount percent and the minimum age are NEVER written here: they come from the
   server's program object. viewOf(), copyFor(), errorFor() and fmtDate() are pure so app/src/student/student-theme-page.test.ts can run them. Everything is drawn with textContent and
   createElement, never markup. The same file ships in the live theme and in v2; each theme styles the stu-* classes itself. */
(function () {
  'use strict';

  var API = '/apps/dashboard/customer/student';
  var COPY = {
    consent: 'Please tick the box to confirm and continue.',
    attest: 'Please confirm your age to continue.',
    email: 'Please enter your school email address.',
    emailNotAccepted: 'We could not confirm that this is a school email we accept. Check the address, or write to us and we will help.',
    wait: 'We have sent a few links already. Please wait a little while and try again.',
    notEligible: 'We could not confirm that you are eligible for Circadia Next.',
    programOff: 'Circadia Next is not open yet.',
    already: 'You are already a member. Please reload the page.',
    failed: 'Something went wrong. Please try again in a little while.',
    verification: 'We could not verify you this time. Please try again.',
    network: 'We could not reach Circadia. Check your connection and try again.',
    unavailable: 'Circadia Next is not available right now. Please try again later.',
    signin: 'Please sign in again and retry.'
  };

  var dateFmt = typeof Intl !== 'undefined' ? new Intl.DateTimeFormat('en-CA', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'America/Toronto' }) : null;
  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    return isNaN(d.getTime()) || !dateFmt ? '' : dateFmt.format(d);
  }

  // What to show, from the server's own program and member objects.
  function viewOf(data) {
    var program = data && data.program ? data.program : null;
    var member = data && data.member ? data.member : null;
    if (!program || program.enabled !== true) return { kind: 'off', chip: { cls: 'soon', label: 'Not open yet' }, action: null };
    if (!member) return { kind: 'join', chip: { cls: 'open', label: 'Open' }, action: { path: 'verify', label: 'Verify I am a student' } };
    if (member.state === 'active') return { kind: 'active', chip: { cls: 'selected', label: 'Member' }, action: null };
    if (member.state === 'renewal_open' || member.state === 'grace') return { kind: 'renew', chip: { cls: 'wait', label: 'Renewal open' }, action: { path: 'renew', label: 'Renew my membership' } };
    if (member.state === 'lapsed') return { kind: 'lapsed', chip: { cls: '', label: 'Lapsed' }, action: { path: 'renew', label: 'Renew to get the discount back' } };
    if (member.state === 'term_ended') return { kind: 'ended', chip: { cls: '', label: 'Term ended' }, action: { path: 'verify', label: 'Join again' } };
    return { kind: 'off', chip: { cls: 'soon', label: 'Not open yet' }, action: null };
  }

  // The words around the numbers the server sent.
  function copyFor(program, member) {
    var pct = program && typeof program.discount_percent === 'number' ? program.discount_percent : null;
    var age = program && typeof program.min_age === 'number' ? program.min_age : null;
    var lede = (pct === null ? 'Verified students get a discount' : 'Verified students get ' + pct + '% off') + '. Circadia Next is a four year membership: you check in once a year, and renewing is quick.';
    var rule = 'This discount is not combined with a subscription or any other percentage discount. At checkout you get whichever is better.';
    var who = 'For post-secondary students' + (age === null ? '.' : ' aged ' + age + ' or older.');
    var consent = 'I am a post-secondary student and I agree to the student program terms.';
    var attest = age === null ? 'I confirm that I am an adult.' : 'I confirm that I am ' + age + ' or older.';
    var note = 'We use your school email only to send you one link. We do not keep the address.';
    var line = '';
    if (member) {
      var due = fmtDate(member.due_at), end = fmtDate(member.term_ends_at);
      if (member.state === 'active') line = 'Your discount is on.' + (due ? ' Your next yearly check is ' + due + '.' : '') + (end ? ' Your membership runs to ' + end + '.' : '');
      else if (member.state === 'renewal_open') line = 'Your yearly check opens now' + (due ? ' and is due ' + due : '') + '. Renew any time before then and your discount does not stop.';
      else if (member.state === 'grace') line = 'Your yearly check is due. Your discount keeps working while you renew.';
      else if (member.state === 'lapsed') line = 'Your discount is paused. Renew' + (end ? ' (your membership runs to ' + end + ')' : '') + ' to get it back. You do not need to sign up again.';
      else if (member.state === 'term_ended') line = 'Your four year membership has ended. If you are still a student, you can join again.';
    }
    return { lede: lede, rule: rule, who: who, consent: consent, attest: attest, note: note, line: line };
  }

  function errorFor(status, body) {
    var code = body && typeof body.error === 'string' ? body.error : '';
    var msg = body && typeof body.message === 'string' ? body.message : '';
    if (status === 401) return { kind: 'banner', message: COPY.signin };
    if (code === 'consent_required') return { kind: 'field', message: msg || COPY.consent };
    if (code === 'attest_required') return { kind: 'attest', message: msg || COPY.attest };
    if (code === 'invalid_school_email') return { kind: 'email', message: msg || COPY.email };
    if (status === 429 || code === 'rate_limited') return { kind: 'banner', message: COPY.wait };
    if (code === 'not_eligible' && body && (body.reason === 'school_domain_not_allowed' || body.reason === 'school_domain_blocked')) return { kind: 'banner', message: COPY.emailNotAccepted };
    if (code === 'program_off') return { kind: 'reload', message: msg || COPY.programOff };
    if (code === 'already_member') return { kind: 'reload', message: msg || COPY.already };
    if (code === 'not_eligible') return { kind: 'banner', message: msg || COPY.notEligible };
    if (code === 'verification_failed') return { kind: 'banner', message: msg || COPY.verification };
    if (status === 503) return { kind: 'banner', message: COPY.unavailable };
    return { kind: 'banner', message: msg || COPY.failed };
  }

  // After the link is sent: only the domain is named, never the address.
  function emailSentCopy(domain) {
    var where = typeof domain === 'string' && domain ? 'your ' + domain + ' address' : 'your school email';
    return { heading: 'Check your school inbox', body: 'We sent a link to ' + where + '. It works once and lasts an hour. Press it to finish verifying. If it is not there, look in spam.' };
  }

  // A vendor hand-off may only be followed to a secure address.
  function safeRedirect(url) {
    return typeof url === 'string' && /^https:\/\//i.test(url) ? url : null;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { viewOf: viewOf, copyFor: copyFor, errorFor: errorFor, fmtDate: fmtDate, safeRedirect: safeRedirect, emailSentCopy: emailSentCopy };

  /* ---- browser only ---- */
  if (typeof document === 'undefined' || typeof window === 'undefined' || !document) return;
  // NOTHING IS OFFERED UNTIL THE SWITCH IS ON (Eric 2026-11-03): the page ships saying it is not open yet, and everything that reads as the offer (the lede, the sign-in prompt) is hidden until the server says the programme is enabled.
  // A failed or odd answer leaves it closed.
  function reveal(on) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-stu-open-only]'), function (e) { e.hidden = !on; });
    Array.prototype.forEach.call(document.querySelectorAll('[data-stu-closed]'), function (e) { e.hidden = on; });
  }
  var root = document.querySelector('[data-student-root]');
  if (!root) {
    // a signed-out visitor: ask the anonymous status route whether the programme is open
    if (typeof fetch === 'function') {
      fetch('/apps/dashboard/student/status', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (b) { reveal(!!(b && b.program && b.program.enabled === true)); }, function () { reveal(false); });
    }
    return;
  }

  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'text') e.textContent = attrs[k]; else if (k === 'class') e.className = attrs[k]; else e.setAttribute(k, attrs[k]); }
    (kids || []).forEach(function (c) { if (c) e.appendChild(c); });
    return e;
  }

  function render(data) {
    var program = data.program || {};
    reveal(program.enabled === true);
    var v = viewOf(data);
    var c = copyFor(program, data.member);
    root.textContent = '';
    var info = h('div', { class: 'stu-info' }, [
      h('span', { class: 'stu-chip ' + v.chip.cls }, [h('i'), document.createTextNode(v.chip.label)]),
      h('h2', { text: 'Circadia Next' }),
      h('p', { class: 'stu-desc', text: c.lede }),
      h('p', { class: 'stu-desc', text: c.who }),
      h('p', { class: 'stu-desc', text: c.rule })
    ]);
    var act = h('div', { class: 'stu-act' });
    if (v.kind === 'off') {
      act.appendChild(h('div', { class: 'stu-state' }, [h('h3', { text: 'Not open yet' }), h('p', { text: COPY.programOff })]));
    } else if (v.kind === 'active') {
      act.appendChild(h('div', { class: 'stu-state' }, [h('h3', { text: 'You are a member' }), h('p', { text: c.line })]));
    } else {
      var headings = { join: 'Verify you are a student', renew: 'Renew your membership', lapsed: 'Get your discount back', ended: 'Join again' };
      if (c.line) act.appendChild(h('div', { class: 'stu-state' }, [h('h3', { text: headings[v.kind] }), h('p', { text: c.line })]));
      act.appendChild(form(v, c));
    }
    if (data.member && data.member.discount_applies === true) act.appendChild(discountBox());
    root.appendChild(h('article', { class: 'stu-card' + (v.kind === 'join' || v.kind === 'renew' || v.kind === 'lapsed' || v.kind === 'ended' ? '' : ' quiet'), 'aria-labelledby': 'stu-title' }, [info, act]));
  }

  // The member's discount code (POST .../student/discount): one code, single use, short-lived; the server refuses at the monthly cap and says so.
  var DISCOUNT_COPY = { cap: 'You have reached the monthly limit for student pricing. It resets next month.', unavailable: 'Your discount code is not available right now. Please try again later.', failed: 'We could not get your code. Please try again.' };
  function discountBox() {
    var box = h('div', { class: 'stu-state stu-code' });
    var msg = h('p', { class: 'stu-banner', role: 'alert' });
    var out = h('p', { class: 'stu-desc', 'aria-live': 'polite' });
    var btn = h('button', { type: 'button', class: 'stu-btn', text: 'Get my discount code' });
    btn.addEventListener('click', function () {
      msg.textContent = ''; out.textContent = ''; btn.disabled = true;
      post('discount', {}).then(function (x) {
        btn.disabled = false;
        if (x.ok && x.body && typeof x.body.code === 'string') {
          var until = x.body.expires_at ? fmtDate(x.body.expires_at) : '';
          out.textContent = 'Your code: ' + x.body.code + '. It works for one order' + (until ? ' until ' + until : '') + ' and is not combined with other percentage discounts.';
          return;
        }
        var code = x.body && typeof x.body.error === 'string' ? x.body.error : '';
        msg.textContent = code === 'monthly_cap_reached' ? DISCOUNT_COPY.cap : (code === 'discount_unavailable' || x.status === 503) ? DISCOUNT_COPY.unavailable : ((x.body && typeof x.body.message === 'string' && x.body.message) || DISCOUNT_COPY.failed);
      }).catch(function () { btn.disabled = false; msg.textContent = COPY.network; });
    });
    box.appendChild(h('h3', { text: 'Your discount code' }));
    box.appendChild(btn); box.appendChild(msg); box.appendChild(out);
    return box;
  }

  function form(v, c) {
    var f = h('form', { novalidate: '' });
    var emailLabel = h('label', { for: 'stu-school-email', class: 'stu-label', text: 'School email' });
    var email = h('input', { type: 'email', id: 'stu-school-email', name: 'school_email', autocomplete: 'email', inputmode: 'email', 'aria-describedby': 'stu-email-note' });
    var emailNote = h('p', { id: 'stu-email-note', class: 'stu-desc', text: c.note });
    var emailErr = h('p', { class: 'stu-err', role: 'alert' });
    var box = h('input', { type: 'checkbox', id: 'stu-consent', 'aria-describedby': 'stu-consent-text' });
    var consentErr = h('p', { class: 'stu-err', role: 'alert' });
    var ageBox = h('input', { type: 'checkbox', id: 'stu-attest', 'aria-describedby': 'stu-attest-text' });
    var ageErr = h('p', { class: 'stu-err', role: 'alert' });
    var banner = h('p', { class: 'stu-banner', role: 'alert' });
    var send = h('button', { type: 'submit', class: 'stu-btn', text: v.action.label });
    f.appendChild(h('div', { class: 'stu-field' }, [emailLabel, email, emailNote, emailErr]));
    f.appendChild(h('div', { class: 'stu-terms' }, [h('label', { class: 'stu-box' }, [box, h('span', { id: 'stu-consent-text', text: c.consent })]), consentErr]));
    f.appendChild(h('div', { class: 'stu-terms' }, [h('label', { class: 'stu-box' }, [ageBox, h('span', { id: 'stu-attest-text', text: c.attest })]), ageErr]));
    f.appendChild(banner);
    f.appendChild(send);
    f.addEventListener('submit', function (ev) {
      ev.preventDefault();
      emailErr.textContent = ''; consentErr.textContent = ''; ageErr.textContent = ''; banner.textContent = '';
      var address = email.value.replace(/^\s+|\s+$/g, '');
      if (address.indexOf('@') < 1) { emailErr.textContent = COPY.email; email.focus(); return; }
      if (!box.checked) { consentErr.textContent = COPY.consent; box.focus(); return; }
      if (!ageBox.checked) { ageErr.textContent = COPY.attest; ageBox.focus(); return; }
      send.disabled = true; f.setAttribute('aria-busy', 'true');
      post(v.action.path, { consent: true, attest_age18: true, school_email: address }).then(function (x) {
        f.removeAttribute('aria-busy');
        if (x.ok && x.body && x.body.status === 'email_sent') {
          var sent = emailSentCopy(x.body.domain);
          f.textContent = '';
          f.appendChild(h('div', { class: 'stu-state' }, [h('h3', { text: sent.heading }), h('p', { text: sent.body })]));
          return;
        }
        if (x.ok && x.body && x.body.status === 'redirect') {
          var to = safeRedirect(x.body.redirect_url);
          if (to) { window.location.assign(to); return; }
          send.disabled = false; banner.textContent = COPY.failed; return;
        }
        if (x.ok) return load();
        send.disabled = false;
        var out = errorFor(x.status, x.body);
        if (out.kind === 'field') consentErr.textContent = out.message;
        else if (out.kind === 'attest') ageErr.textContent = out.message;
        else if (out.kind === 'email') emailErr.textContent = out.message;
        else if (out.kind === 'reload') { banner.textContent = out.message; load(); }
        else banner.textContent = out.message;
      }).catch(function () { f.removeAttribute('aria-busy'); send.disabled = false; banner.textContent = COPY.network; });
    });
    return f;
  }

  function post(path, body) {
    return fetch(API + '/' + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (b) { return { ok: r.ok && !(b && b.ok === false), status: r.status, body: b }; }); });
  }

  function load() {
    return fetch(API, { credentials: 'same-origin' })
      .then(function (r) { return r.json().catch(function () { return null; }).then(function (b) { return { r: r, b: b }; }); })
      .then(function (x) {
        if (!x.r.ok || !x.b || x.b.ok !== true) { root.textContent = ''; root.appendChild(h('p', { class: 'stu-banner', role: 'alert', text: errorFor(x.r.status, x.b).message })); return; }
        render(x.b);
      })
      .catch(function () { root.textContent = ''; root.appendChild(h('p', { class: 'stu-banner', role: 'alert', text: COPY.network })); });
  }
  root.setAttribute('aria-live', 'polite');
  load();
})();
